import React, {useEffect} from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {SubTitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';
import css from './booking-reschedule-form.css';
import {ReasonInput} from '../reason-form/reason-input';
import {zodResolver} from '@hookform/resolvers/zod';
import {getReasonFormSchema} from '../reason-form/reason-form.schema';
import {useForm} from 'react-hook-form';
import {z} from 'zod';
import {useBookingMachine} from '../../hooks/useBookingMachine';

import {useSelector} from '@xstate/react';
import {BrandButton} from '../../lib/brand-button/brand-button';
import {selectError} from '../../selectors/commonSelector';
import {selectSelectedTimeSlot} from '../../selectors/booking-selector';

import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';


export const BookingRescheduleForm = () => {
  const {t} = useLabelTranslation();

  const {bookingActor, bookingState} = useBookingMachine();
  const selectedTimeSlot = useSelector(bookingActor, selectSelectedTimeSlot);
  const {errorMessage} = useSelector(bookingActor, (state) =>
    selectError(state, t),
  );

  const hasError = bookingState.matches({
    rescheduleForm: 'retryRescheduleFormSubmit',
  });

  const reasonSchema = getReasonFormSchema(t);
  const methods = useForm<z.infer<typeof reasonSchema>>({
    mode: 'onTouched',
    defaultValues: {
      reason: '',
    },
    resolver: zodResolver(reasonSchema),
  });

  const {control, formState, watch} = methods;

  const reasonValue = watch('reason');
  const handleRescheduleMeeting = () => {
    bookingActor.send({type: 'timeslot.confirm'});
  };

  useEffect(() => {
    bookingActor.send({
      type: 'rescheduleReason.update',
      reason: reasonValue,
    });
  }, [reasonValue]);

  return (
    <>
      <div className={css.rescheduleForm}>
        <SubTitleMedium color="primary" testId="subtitle-medium-story">
          {t(
            'Please_answer_the_following_questions',
            'Please answer the following questions ',
          )}
        </SubTitleMedium>
        <ReasonInput
          control={control}
          reasonName="reason"
          required={true}
          disabled={false}
          actionType="reschedule"
          participantType="CANDIDATE"
        />
      </div>
      <div className={css.rescheduleButtonSection}>
        <BrandButton
          isFluid
          actionType="submit"
          disabled={!selectedTimeSlot || !formState.isValid}
          isLoading={bookingState.matches({
            rescheduleForm: 'rescheduleFormSubmitting',
          })}
          onClick={handleRescheduleMeeting}
        >
          {t('Reschedule_Meeting', 'Reschedule Meeting')}
        </BrandButton>
        {hasError && (
          <InContextAlert leftIconName="shield-exclamation" semantic="danger">
            {/* already translated in errorMessage */}
            {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
            {errorMessage}
          </InContextAlert>
        )}
      </div>
    </>
  );
};
